import type { MessageDescriptor } from "react-intl";

import { isNetworkName } from "./guards";
import { networkNamesMessages } from "./messages";

export const getNetworkSlugName = (
  slug?: string,
): MessageDescriptor | undefined => {
  if (isNetworkName(slug)) {
    return networkNamesMessages[slug];
  }

  return undefined;
};
